import { assertNever } from '@kofno/piper';
import { action, makeObservable, observable } from 'mobx';
import { SearchParameter } from '../../../ListFilter/Types';
import { Link } from '../../../Resource/Types';
import {
  LoadError,
  ProductLicensesOverviewResource,
  State,
  loading,
  loadingError,
  ready,
  updatedSearchParameters,
  waiting,
} from './Types';

export class ProductLicensesStore {
  @observable
  state: State = waiting();

  constructor() {
    makeObservable(this);
  }

  @action
  loading = (link: Link): void => {
    switch (this.state.kind) {
      case 'waiting':
      case 'ready':
        this.state = loading(link, this.state.searchParameters);
        break;
      case 'loading':
      case 'loading-error':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  loadingError = (error: LoadError): void => {
    switch (this.state.kind) {
      case 'loading':
        this.state = loadingError(this.state.link, error);
        break;
      case 'waiting':
      case 'loading-error':
      case 'ready':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  ready = (resource: ProductLicensesOverviewResource): void => {
    switch (this.state.kind) {
      case 'loading':
        this.state = ready(resource, this.state);
        break;
      case 'waiting':
      case 'loading-error':
      case 'ready':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  updatingSearchParameters = (searchParameter: SearchParameter) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'loading':
      case 'loading-error':
        break;
      case 'ready':
        const searchParameters = updatedSearchParameters(
          this.state.searchParameters,
          searchParameter,
        );
        this.state = loading(this.state.link, searchParameters);
        break;
      default:
        assertNever(this.state);
    }
  };
}
